import { ChartIntervalTypes } from 'pages/index-details/storage/interface'

export interface StateConfig {
  name: ChartIntervalTypes
  range: number
}

export interface ProductTimeSeriesItem {
  x: string
  y: string
  tokenHeld?: string
  price: string
  avgPrice: string
  investedCapital: string
  investmentValue: string
}

export interface ChartData {
  basePrice: string
  arrTimeline: ProductTimeSeriesItem[]
  currentAPY?: string
  additionalTimeline?: { x: string; y: string }[]
}
/**
 * name : element id and displayed Text
 * value: Type fetched steps
 * range: Range fetched Data
 */
export const ChartIntervalSet: StateConfig[] = [
  { name: '1 month', range: 2635200 },
  { name: '3 months', range: 7948800 },
  { name: '1 year', range: 31536000 },
  { name: 'All time', range: 3153600000 }, //100 years
]

export const getDefaultChartInterval = (): StateConfig => {
  return ChartIntervalSet[2]
}

export const pickChartInterval = (name: string): StateConfig => {
  return ChartIntervalSet.find((item) => item.name === name) ?? getDefaultChartInterval()
}

export const getDefaultChartData = () => ({ basePrice: '0', arrTimeline: [] })
